import React from 'react';
import type { MenuSearchResult } from '../../utils/menuSearch';
import { getSearchResultIcon } from './menuIcons';

interface MenuSearchResultsProps {
  results: MenuSearchResult[];
  listboxId: string;
  activeIndex: number;
  onSelect: (result: MenuSearchResult) => void;
  onHighlight: (index: number) => void;
}

const MenuSearchResults: React.FC<MenuSearchResultsProps> = ({
  results,
  listboxId,
  activeIndex,
  onSelect,
  onHighlight,
}) => {
  if (results.length === 0) {
    return (
      <div className="sidebar-search-empty" role="status">
        موردی پیدا نشد
      </div>
    );
  }

  return (
    <ul id={listboxId} className="sidebar-search-results" role="listbox" aria-label="نتایج جستجو">
      {results.map((result, index) => {
        const optionId = `${listboxId}-option-${index}`;
        const isActive = index === activeIndex;

        return (
          <li key={`${result.type}-${result.dashboardId}-${result.sectionId ?? 'root'}`} role="presentation">
            <button
              type="button"
              id={optionId}
              role="option"
              aria-selected={isActive}
              className={`menu-item sidebar-search-result-item${isActive ? ' sidebar-search-result-item--active' : ''}`}
              onMouseEnter={() => onHighlight(index)}
              onClick={() => onSelect(result)}
            >
              <div className="item-icon">
                {getSearchResultIcon(result.type, result.icon)}
              </div>
              <span className="item-text sidebar-search-result-text">
                <span className="sidebar-search-result-title">{result.title}</span>
                <span className="sidebar-search-result-breadcrumb">{result.breadcrumb}</span>
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default MenuSearchResults;
